/**
 * Google Tag Manager container for Smile Design Secret.
 * GTM is only injected after the visitor accepts cookies — see `@/components/generals/analytics`.
 */
export const GTM_CONTAINER_ID = 'GTM-5ML4WW2W'

/** Where the visitor's cookie decision is remembered (first-party, strictly necessary). */
export const CONSENT_STORAGE_KEY = 'sds-cookie-consent'

/** Bump this to re-ask everyone (e.g. when a new tracking vendor is added). */
export const CONSENT_VERSION = 1

/** Fired on the window whenever the visitor accepts or declines. */
export const CONSENT_CHANGE_EVENT = 'sds:consent-change'

/** Fired on the window to re-open the banner from a "Cookie settings" link. */
export const CONSENT_OPEN_EVENT = 'sds:consent-open'

/** Cookie name prefixes written by Google Analytics / Ads, cleared when consent is withdrawn. */
export const GOOGLE_COOKIE_PREFIXES = ['_ga', '_gid', '_gat', '_gcl'] as const

/** Last meaningful edit to the privacy policy copy. Update when the policy changes. */
export const PRIVACY_POLICY_UPDATED = '2026-08-31'
